import { render, staticRenderFns } from "./DownloadFileScreen.vue?vue&type=template&id=64395464&scoped=true&"
import script from "./DownloadFileScreen.vue?vue&type=script&lang=ts&"
export * from "./DownloadFileScreen.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadFileScreen.vue?vue&type=style&index=0&id=64395464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64395464",
  null
  
)

export default component.exports